var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetpayIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#23AD1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.587 28L21 22.41V13H22.998V21.582L28 26.587L26.587 28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8C23.8655 7.99942 25.7122 8.37395 27.4301 9.10131C29.148 9.82866 30.7021 10.894 32 12.234V8H34V16H26V14H30.922C29.0485 11.9194 26.5055 10.5607 23.7346 10.1595C20.9637 9.75843 18.1399 10.3403 15.7533 11.8042C13.3667 13.268 11.568 15.5214 10.6696 18.1732C9.77124 20.8249 9.82981 23.7075 10.8352 26.3205C11.8405 28.9336 13.7292 31.1121 16.1733 32.4778C18.6174 33.8435 21.4626 34.3102 24.2149 33.7968C26.9672 33.2835 29.4529 31.8225 31.2404 29.6676C33.0278 27.5126 34.0042 24.7998 34 22H36C36 24.7689 35.1789 27.4757 33.6406 29.778C32.1022 32.0803 29.9157 33.8747 27.3576 34.9343C24.7994 35.9939 21.9845 36.2712 19.2687 35.731C16.553 35.1908 14.0584 33.8574 12.1005 31.8995C10.1426 29.9416 8.80921 27.447 8.26901 24.7313C7.72882 22.0155 8.00607 19.2006 9.06569 16.6424C10.1253 14.0843 11.9197 11.8978 14.222 10.3594C16.5243 8.82109 19.2311 8 22 8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetpayIn);
export default __webpack_public_path__ + "static/media/netpay_in.30698ecc2593083ce3f380a4e05971d5.svg";
export { ForwardRef as ReactComponent };